import React, { useCallback, useEffect } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  editSbatGroupContestLessonSelector,
  resetEditSbatGroup,
  useBulkUpdateInterviewbitTestsMutation,
} from 'features/classCreation';
import GlobalLoader from 'components/GlobalLoader';

function UpdateGroupContestButton({ sbatGroup }) {
  const dispatch = useDispatch();
  const contestLesson = useSelector(editSbatGroupContestLessonSelector);
  const [bulkUpdateInterviewbitTests, { isLoading, error, isSuccess }] =
    useBulkUpdateInterviewbitTestsMutation();

  const handleOnClick = useCallback(() => {
    bulkUpdateInterviewbitTests({
      lesson: contestLesson,
      interviewbit_tests: contestLesson.meta.interviewbit_tests.map(
        (interviewbitTest) => ({
          ...interviewbitTest,
          id: interviewbitTest.test_id,
        })
      ),
      sbatGroup,
    });
  }, [bulkUpdateInterviewbitTests, contestLesson, sbatGroup]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Group contest details has been successfully updated');
      dispatch(resetEditSbatGroup());
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error?.data) {
      cogoToast.error(error.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  return (
    <>
      <GlobalLoader isVisible={isLoading} />
      <Tappable
        className="btn btn-primary btn-long"
        disabled={isLoading}
        onClick={handleOnClick}
      >
        Save Changes
      </Tappable>
    </>
  );
}

export default UpdateGroupContestButton;
